// extracted by mini-css-extract-plugin
module.exports = {"account":"PictoAccount_account__suy8E","submenu":"PictoAccount_submenu__jZUwm"};